export const isLexicalEmpty = (value) => {
  if (!value) return true;

  // Check if it's a Lexical input object
  if (value.type !== 'lexical' || !value.value?.root) return true;

  // Get the first paragraph node
  const firstParagraph = value.value.root.children[0];

  // Check if it's a paragraph with no children
  return !firstParagraph?.children?.length;
};
